import { type GenericGeneralFilterGroup } from '@autone/ui';
import { type Get } from 'type-fest';

import { type AssortmentGeneralFilterTranslatedOptions } from '../../../../hooks';
import {
  type AssortmentSessionStorageAtomData,
  type TableNamesWithGeneralFilters,
} from '../../../../storage/session-storage';

export type GetRelevantGeneralFilterGroupsFn<
  TableName extends TableNamesWithGeneralFilters,
> = (
  options: AssortmentGeneralFilterTranslatedOptions,
) => GenericGeneralFilterGroup<
  Extract<
    keyof Get<AssortmentSessionStorageAtomData, `${TableName}.generalFilters`>,
    string
  >
>[];

export const ASSORTMENT_GENERAL_FILTERS_CONFIG_MAP = {
  productLocationsTable: ({ geographic, location_clusters }) => [
    ...geographic,
    ...location_clusters,
  ],
  productsTable: ({ product, geographic, location_clusters }) => [
    ...product,
    ...geographic,
    ...location_clusters,
  ],
  skuLocationsTable: ({ product, geographic, location_clusters, sku }) => [
    ...product,
    ...geographic,
    ...location_clusters,
    ...sku,
  ],
} as const satisfies {
  [T in TableNamesWithGeneralFilters]: GetRelevantGeneralFilterGroupsFn<T>;
};
